import { useEffect } from 'react';
import { init, replayIntegration } from '@sentry/react';
import packageInfo from '../../package.json';
import { isCrawler } from './authentication';

// This regex will be used to check against the error's file path
const ALLOWED_DOMAIN_REGEX = /tennistalker\.it|localhost/;

const LoadSentry = () => {
  useEffect(() => {
    const { version } = packageInfo;
    if (window.location.hostname !== 'localhost' && !isCrawler()) {
      init({
        dsn: 'https://da6cfcb5411ffe5ee96fe222f93a4c58@o4508523405770752.ingest.de.sentry.io/4508523407736912',
        integrations: [
          // reactRouterV7BrowserTracingIntegration({
          //   useEffect: useEffect,
          //   useLocation,
          //   useNavigationType,
          //   createRoutesFromChildren,
          //   matchRoutes,
          // }),
          replayIntegration(),
        ],
        // This is the key part 👇
        allowUrls: [
          // This will match https://tennistalker.it and https://www.tennistalker.it
          /^https?:\/\/((www)\.)?tennistalker\.it/,

          // Keep this line to capture errors during local development
          // /^http:\/\/localhost:\d+/,
        ],
        /**
         * This function is the ultimate filter. It will inspect every event
         * and discard any that don't originate from your code.
         */
        beforeSend(event) {
          try {
            // Check if there is an exception in the event.
            if (event?.exception?.values?.length) {
              const stacktrace = event.exception.values[0].stacktrace;

              if (stacktrace?.frames?.length) {
                // Get the very last frame in the stack trace, which is the error's origin
                const lastFrame = stacktrace.frames[stacktrace.frames.length - 1];

                // The filename property holds the URL of the script that caused the error
                const errorOriginUrl = lastFrame.filename;

                if (errorOriginUrl) {
                  // Check if the error's origin URL matches our allowed domains
                  if (ALLOWED_DOMAIN_REGEX.test(errorOriginUrl)) {
                    // It's from our code, so let's send it.
                    return event;
                  } else {
                    // It's from an external script, so we discard it by returning null.
                    console.warn(`Sentry: Discarding error from external script: ${errorOriginUrl}`);
                    return null;
                  }
                }
              }
            }
          } catch (error) {
            console.error('Sentry: Error while processing event', error);
          }
          // For any other event type (like transactions) that we don't want to filter, send it.
          return event;
        },
        release: version,
        environment: import.meta.env.VITE_ENV,
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      });
    }
  }, []);

  return <></>;
};

export default LoadSentry;
